import  removeAccents  from 'remove-accents';

export function makeSearchFriendly(str) {
  const searchTermRegex = /[^\w\s]|\s|\b(^the|^a\s|^an|^and)\b/gi;
  if (!str) {
    return '';
  }
  return removeAccents(str).toLowerCase().replace(searchTermRegex, '');
}

export function formatSearchQuery(str) {
  const searchTermRegex = /[^\w|\s]|\b(^the|^a\s|^an|^and)\b/gi;
  if (!str) {
    return '';
  }
  const stripped = removeAccents(str)
    .trim()
    .toLowerCase()
    .replace(searchTermRegex, '')
    .replace(/ /g, '%20');

  return `${stripped}|${stripped.split('%20').join('')}*`;
}
